export const TROMBINOS_INITIAL_FORM = {
  nom: "",
  prenom: "",
  fonction: "",
  role_type: "",
  groupe: "",
  service_id: "",
  mail_pro: "",
  tel_pro: "",
  photo_url: "",
  presentation_courte: "",
  bio_html: "",
  mandat_debut: "",
  mandat_fin: "",
  ordre_affichage: 0,
  is_elected: false,
  is_visible: true,
};

export const TROMBINOS_ELECTED_FILTER_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "elected",
    label: "Élus municipaux",
  },
  {
    value: "personnel",
    label: "Personnel communal",
  },
];

export const TROMBINOS_VISIBLE_FILTER_OPTIONS = [
  {
    value: "all",
    label: "Tous",
  },
  {
    value: "visible",
    label: "Visibles",
  },
  {
    value: "hidden",
    label: "Masqués",
  },
];

export const TROMBINOS_ROLE_TYPE_OPTIONS = [
  {
    value: "",
    label: "Non renseigné",
  },
  {
    value: "elu",
    label: "Élu",
  },
  {
    value: "personnel",
    label: "Personnel",
  },
  {
    value: "autre",
    label: "Autre",
  },
];

export const TROMBINOS_LIMIT_OPTIONS = [12, 24, 48, 96];

export const TROMBINOS_GROUP_SUGGESTIONS = [
  "Majorité municipale",
  "Opposition",
  "Conseil municipal",
  "Direction générale",
  "Services administratifs",
  "Services techniques",
  "Accueil mairie",
  "État civil",
  "Urbanisme",
  "Éducation",
  "Sport et jeunesse",
  "Culture",
  "Solidarité",
];

export const TROMBINOS_FUNCTION_SUGGESTIONS = [
  "Maire",
  "Premier adjoint",
  "Adjoint au maire",
  "Conseiller municipal",
  "Conseiller délégué",
  "Directeur général des services",
  "Responsable de service",
  "Agent d’accueil",
  "Responsable communication",
  "Responsable urbanisme",
  "Responsable vie associative",
];

export const TROMBINOS_FORM_HELPERS = [
  "Nom, prénom et fonction sont obligatoires.",
  "La photo peut être choisie dans la photothèque ou saisie avec une URL.",
  "Le champ “visible” permet de préparer une fiche sans l’afficher immédiatement.",
  "Le champ “élu municipal” sert à séparer les élus du personnel communal.",
];